.SpinnerWrapper {
  display: flex;
  justify-content: center;
  padding: var(--base-size-16);
}

.EmptyStateWrapper {
  padding: var(--base-size-16);
}
